module.exports = __webpack_public_path__ + "static/media/removeicon.fde9fde6.svg";